/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type VerticalType = "art" | "fashion" | "furniture" | "jewelry" | "%future added value";
export type SbRespMainContent_itemSearch = {
    readonly topCategoryL1: VerticalType | null;
    readonly displayUriRef: string | null;
    readonly pageType: string | null;
    readonly displayMaxNumberOfPages: number | null;
    readonly bottomModule: ReadonlyArray<{
        readonly " $fragmentRefs": FragmentRefs<"SharedBottomModule_bottomModule">;
    } | null> | null;
    readonly " $fragmentRefs": FragmentRefs<"SbRespRefineMenuSelector_itemSearch" | "SbRespSortItems_itemSearch" | "SbRespPageSize_itemSearch" | "SbRespBrowseHeader_itemSearch" | "SbRespSearchResultContainer_itemSearch" | "SbSharedRelatedItems_itemSearch" | "SbRespRefineTopNav_itemSearch">;
    readonly " $refType": "SbRespMainContent_itemSearch";
};
export type SbRespMainContent_itemSearch$data = SbRespMainContent_itemSearch;
export type SbRespMainContent_itemSearch$key = {
    readonly " $data"?: SbRespMainContent_itemSearch$data;
    readonly " $fragmentRefs": FragmentRefs<"SbRespMainContent_itemSearch">;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "SbRespMainContent_itemSearch",
  "type": "ItemSearchQueryConnection",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "topCategoryL1",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "displayUriRef",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "pageType",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "displayMaxNumberOfPages",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "bottomModule",
      "storageKey": null,
      "args": null,
      "concreteType": "BottomModule",
      "plural": true,
      "selections": [
        {
          "kind": "FragmentSpread",
          "name": "SharedBottomModule_bottomModule",
          "args": null
        }
      ]
    },
    {
      "kind": "FragmentSpread",
      "name": "SbRespRefineMenuSelector_itemSearch",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "SbRespSortItems_itemSearch",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "SbRespPageSize_itemSearch",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "SbRespBrowseHeader_itemSearch",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "SbRespSearchResultContainer_itemSearch",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "SbSharedRelatedItems_itemSearch",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "SbRespRefineTopNav_itemSearch",
      "args": null
    }
  ]
};
(node as any).hash = 'c4f10c74f3b20481f0023b944a84d462';
export default node;
